import React from 'react';
import PropTypes from 'prop-types';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import CloseIcon from 'material-ui/svg-icons/content/clear';

import componentBase from '../../../../../../../../../../../src/lib/component-base';

const MOMENTARY_TIMEOUT = 3000;

@componentBase('FlightMapNote')
export default class FlightMapNote extends React.Component {
  static propTypes = {
    note: PropTypes.object.isRequired,
    onClose: PropTypes.func,
  };

  render() {
    const { onClose, note } = this.props;
    const noteClassNames = ['flight-map-note'];

    if (note.landed) {
      noteClassNames.push('disabled');
    } else if (note.trackingUnavailable || note.canceled) {
      noteClassNames.push('alert');
    } else {
      noteClassNames.push('notice');
    }

    let announcement = '';

    if (note.momentary) {
      announcement = 'Tracking Ready';
      setTimeout(onClose, MOMENTARY_TIMEOUT);
    } else if (note.final) {
      announcement = 'Tracking Not Available';
    } else {
      announcement = 'Tracking Currently Unavailable';
    }

    return (
      <div className={noteClassNames.join(' ')}>
        <div className='close-button'>
          <FloatingActionButton
            mini
            backgroundColor='rgba(0,0,0, 0.33)'
            style={{ backgroundColor: 'none' }}
            onTouchStart={this.props.onClose}
            onMouseUp={this.props.onClose}
          >
            <CloseIcon />
          </FloatingActionButton>
        </div>
        <div className='note-text centered'>
          <h1>{announcement}</h1>
          <h4>{note.message}</h4>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightPositionalInformationSection/children/FlightPositionalInformation/children/FlightMap/children/FlightMapNote.js